"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchMissingFiles = exports.handleCopyMoveTarget = exports.handleMissingItem = exports.fetchProjectFilelistWidth = exports.saveProjectFilelistWidth = exports.fetchGroups = exports.fetchProjects = exports.setFiltering = exports.fethProjectFilelistColumns = exports.projectFilelistColumns = exports.toggleNotifications = exports.refreshFiles = exports.unbookmarkFile = exports.bookmarkFile = exports.columnNameParameter = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const redux_observable_1 = require("redux-observable");
const ActionTypes = require("../../actionTypes/files");
const _PropertiesActionTypes = require("../../modules/files/crud/actionTypes");
const _fileListActionTypes = require("../../modules/files/list/actionTypes");
const Actions = require("../../actions/files");
const TypesLib = require("@caddigital/sok-types");
const PropertiesActionTypes = _PropertiesActionTypes.default('files');
const fileListActionTypes = _fileListActionTypes.default('files');
const errorHandling_1 = require("../../utils/errorHandling");
// Here should be only file list epics
const columnNameParameter = (searchOptions) => {
    if (searchOptions.columnName &&
        searchOptions.columnName.toUpperCase() !== 'NAME') {
        return `&columnName=${searchOptions.columnName}`;
    }
    return '';
};
exports.columnNameParameter = columnNameParameter;
function bookmarkFile(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.BOOKMARK_FILE_REQUEST).pipe((0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'PUT',
        body: payload,
        url: `${baseUrl}api/files/bookmark`
    }).pipe((0, operators_1.mergeMap)(({ response }) => ActionTypes.iBookmarkFileSuccessData
        .decode(response)
        .fold((error) => (0, rxjs_1.of)(Actions.bookmarkFileFailure((0, errorHandling_1.parseValidationError)(error))), (res) => (0, rxjs_1.of)(Actions.bookmarkFileSuccess(res)))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.bookmarkFileFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.bookmarkFile = bookmarkFile;
function unbookmarkFile(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.UNBOOKMARK_FILE_REQUEST).pipe((0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'PUT',
        body: payload,
        url: `${baseUrl}api/files/bookmark`
    }).pipe((0, operators_1.mergeMap)(({ response }) => ActionTypes.iUnbookmarkFileSuccessData
        .decode(response)
        .fold((error) => (0, rxjs_1.of)(Actions.unbookmarkFileFailure((0, errorHandling_1.parseValidationError)(error))), (res) => (0, rxjs_1.of)(Actions.unbookmarkFileSuccess(res)))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.unbookmarkFileFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.unbookmarkFile = unbookmarkFile;
// should be used in such a cases when
// we want to refresh file listing based on some other action
function refreshFiles(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action, idx) => action.type === PropertiesActionTypes.CLOSE_OVERLAY ||
        action.type === ActionTypes.REFRESH_FILES), (0, operators_1.mergeMap)(() => {
        const state = store.value;
        const sortByOptions = state.files.sortByOptions;
        const currentFolder = state.files.currentFolder !== null
            ? state.files.currentFolder.id
            : undefined;
        const doAction = [];
        let queryParametes = undefined;
        if (state.files.fileBrowser.enabled) {
            queryParametes = {
                markAutomaticOrderFolders: true
            };
        }
        if (currentFolder) {
            doAction.push(Actions.fetchFiles(currentFolder, sortByOptions, state.files.searchOptions, queryParametes));
        }
        return (0, rxjs_1.from)(doAction);
    }));
}
exports.refreshFiles = refreshFiles;
function toggleNotifications(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.TOGGLE_NOTIFICATIONS_REQUEST).pipe((0, operators_1.mergeMap)(({ payload: { files, status, notificationType } }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'PUT',
        body: {
            arr: files.map((file) => (Object.assign(Object.assign({}, file), { fileOrFolder: file.type === 'FOLDER' ? 'FOLDER' : 'FILE', flag: status, notificationType: notificationType.toLowerCase() })))
        },
        url: `${baseUrl}api/files/setnotifications`
    }).pipe((0, operators_1.map)(({ status, response }) => {
        if (status === 200) {
            return Actions.toggleNotificationsSuccess();
        }
        return Actions.toggleNotificationsFailure((0, errorHandling_1.parseAjaxErrorResponse)(response));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.toggleNotificationsFailure(error))))));
}
exports.toggleNotifications = toggleNotifications;
function projectFilelistColumns(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.TOGGLE_ALL_METADATA_COLUMNS).pipe((0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'PUT',
        body: {
            projectId: payload.projectId,
            metadata: payload.metadatas,
            selected: payload.selected
        },
        url: payload.selected === true
            ? `${baseUrl}api/project/hideFilelistColumn`
            : `${baseUrl}api/project/showFilelistColumn`
    }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.fetchFileListColumns(payload.projectId))), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.fetchFileListColumnsFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.projectFilelistColumns = projectFilelistColumns;
function fethProjectFilelistColumns(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.FETCH_FILELIST_COLUMNS).pipe((0, operators_1.mergeMap)(({ projectId }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/project/${projectId}/getFileListColumns`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = t
            .array(TypesLib.CustomMeta.iMetadata)
            .decode(response);
        const act = validation.fold((e) => Actions.fetchFileListColumnsFailure((0, errorHandling_1.parseValidationError)(e)), (metadatas) => Actions.fetchFileListColumnsSuccess(metadatas));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.fetchFileListColumnsFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.fethProjectFilelistColumns = fethProjectFilelistColumns;
function setFiltering(action$, store) {
    return action$.ofType(ActionTypes.SET_FILTERING_TYPE).pipe((0, operators_1.mergeMap)((_filtering) => {
        const state = store.value;
        // too lazy to type this correctly since our typing for folder is horrible
        // and basically we should always have the id when this gets triggered
        if (state.files.currentFolder === null) {
            return rxjs_1.EMPTY;
        }
        let queryParametes = undefined;
        if (state.files.fileBrowser.enabled) {
            queryParametes = {
                markAutomaticOrderFolders: true
            };
        }
        return (0, rxjs_1.of)(Actions.fetchFiles(state.files.currentFolder.id, state.files.sortByOptions, state.files.searchOptions, queryParametes));
    }));
}
exports.setFiltering = setFiltering;
function fetchProjects(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.IMPORT_FETCH_PROJECT_LIST_REQUEST).pipe((0, operators_1.switchMap)((action) => {
        return ajax({
            headers: {
                Authorization: getToken()
            },
            method: 'GET',
            url: `${baseUrl}api/project`
        }).pipe((0, operators_1.mergeMap)((res) => t
            .array(TypesLib.Project.iProject)
            .decode(res.response)
            .fold(() => (0, rxjs_1.of)(Actions.importFetchProjectListFailure()), (res) => (0, rxjs_1.of)(Actions.importFetchProjectListSuccess(res)))), (0, operators_1.catchError)(() => (0, rxjs_1.of)(Actions.importFetchProjectListFailure())));
    }));
}
exports.fetchProjects = fetchProjects;
function fetchGroups(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.IMPORT_FETCH_GROUP_LIST_REQUEST).pipe((0, operators_1.switchMap)((action) => {
        return ajax({
            headers: {
                Authorization: getToken()
            },
            method: 'GET',
            url: `${baseUrl}api/project/${action.payload.id}/members`
        }).pipe((0, operators_1.mergeMap)((res) => t
            .array(t.interface({
            group: TypesLib.UserGroup.iUserGroup,
            members: t.array(t.any)
        }))
            .decode(res.response)
            .fold(() => (0, rxjs_1.of)(Actions.importFetchGroupListFailure()), (res) => (0, rxjs_1.of)(Actions.importFetchGroupListSuccess(res
            .map((g) => g.group)
            .filter((g) => g.type === 'CategoryUserGroup'))))), (0, operators_1.catchError)(() => (0, rxjs_1.of)(Actions.importFetchGroupListFailure())));
    }));
}
exports.fetchGroups = fetchGroups;
function saveProjectFilelistWidth(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.SAVE_FILELIST_WIDTH_REQUEST).pipe((0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'PUT',
        body: {
            projectId: payload.projectId,
            width: payload.width,
            status: payload.status
        },
        url: `${baseUrl}api/project/fileListWidth`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = t
            .interface({
            saved: t.boolean
        })
            .decode(response);
        const act = validation.fold((e) => Actions.saveProjectFilelistWidthFailure((0, errorHandling_1.parseValidationError)(e)), () => Actions.saveProjectFilelistWidthSuccess());
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.saveProjectFilelistWidthFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.saveProjectFilelistWidth = saveProjectFilelistWidth;
const iFetchProjectFilelistWidthSuccess = t.interface({
    width: t.number,
    status: t.union([t.literal('OPEN'), t.literal('CLOSED')])
});
function fetchProjectFilelistWidth(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.GET_FILELIST_WIDTH).pipe((0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/project/${payload.projectId}/fileListWidth`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        return iFetchProjectFilelistWidthSuccess
            .decode(response)
            .fold((error) => (0, rxjs_1.of)(Actions.getProjectFilelistWidthFailure((0, errorHandling_1.parseValidationError)(error))), (res) => (0, rxjs_1.of)(Actions.getProjectFilelistWidthSuccess(res.width, res.status)));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.getProjectFilelistWidthFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.fetchProjectFilelistWidth = fetchProjectFilelistWidth;
/**
 * Handle file browser missing items
 */
function handleMissingItem(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.INIT_FOLDER_TREE ||
        action.type === fileListActionTypes.FETCH_SUCCESS), (0, operators_1.mergeMap)((action) => {
        const fileBrowser = store.value.files.fileBrowser;
        if (!fileBrowser.tree.data.tree ||
            !fileBrowser.enabled ||
            fileBrowser.missingParents.length === 0) {
            return rxjs_1.EMPTY;
        }
        const fetchMap = {};
        for (const path of fileBrowser.missingParents) {
            for (const item of path) {
                if (item.id === action.payload.node.id) {
                    continue;
                }
                const lFound = fileBrowser.lookup[item.id];
                const qFound = fileBrowser.queue[item.id] || fileBrowser.queue[item.parent];
                if (!lFound && !qFound) {
                    fetchMap[item.id] = item;
                }
                else if (lFound && lFound.getChildren().length === 0) {
                    const meta = lFound.getValue().meta;
                    if (meta && (meta.count || 0) > 0) {
                        fetchMap[item.id] = item;
                    }
                }
            }
        }
        const fetch = Object.values(fetchMap);
        if (fetch.length > 0) {
            return (0, rxjs_1.of)(...fetch.map((x) => Actions.FileBrowserActions.fetchTree(x, ['FOLDER'], 'MINIMAL', undefined, true)));
        }
        return rxjs_1.EMPTY;
    }));
}
exports.handleMissingItem = handleMissingItem;
function handleCopyMoveTarget(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FolderTreeActions.COPY_FILES_SUCCESS), (0, operators_1.mergeMap)((action) => {
        const fileBrowser = store.value.files.fileBrowser;
        if (!fileBrowser.tree.data.tree ||
            !fileBrowser.enabled ||
            !action.payload) {
            return rxjs_1.EMPTY;
        }
        const found = fileBrowser.lookup[action.payload.target.id];
        if (found) {
            return (0, rxjs_1.of)(Actions.FileBrowserActions.fetchTree(found.getValue(), ['FOLDER'], 'MINIMAL', undefined, true));
        }
        return rxjs_1.EMPTY;
    }));
}
exports.handleCopyMoveTarget = handleCopyMoveTarget;
function fetchMissingFiles(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FILE_BROWSER_FETCH_ITEMS_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: { uuids: action.payload.map((f) => f.uuid) },
        url: `${baseUrl}api/files/resource?hierarchyType=MINIMAL&type=FOLDER&markAutomaticOrderFolders=true&includeSubFolders=false`
    }).pipe((0, operators_1.mergeMap)(({ response }) => t
        .array(t.union([
        TypesLib.File._iFolderMinimal,
        TypesLib.File._iRevisionMinimal
    ]))
        .decode(response.files)
        .fold((error) => (0, rxjs_1.of)(Actions.fileBrowserFetchItemsFailure((0, errorHandling_1.parseValidationError)(error), action.payload)), (res) => (0, rxjs_1.of)(Actions.fileBrowserFetchItemsSuccess(res)))), (0, operators_1.catchError)((error) => redux_observable_1.ActionsObservable.of(Actions.fileBrowserFetchItemsFailure((0, errorHandling_1.parseAjaxErrorResponse)(error), action.payload))))));
}
exports.fetchMissingFiles = fetchMissingFiles;
//# sourceMappingURL=filesList.js.map